import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useInteractiveAttributes from '../../../hooks/use-interactive-handler';

const InteractiveBox = ({ selected = false, children, onClick }) => {
  const classes = classNames('ws-ui-color-selector__interactive-box', {
    'ws-ui-color-selector__interactive-box--selected': selected,
  });

  const interactiveAttributes = useInteractiveAttributes(onClick);

  return (
    <div
      className={classes}
      {...(!selected && {
        onClick,
        ...interactiveAttributes,
      })}
    >
      {children}
    </div>
  );
};

InteractiveBox.propTypes = {
  selected: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default InteractiveBox;
